import script from "./CaskUploadInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskUploadInput.vue?vue&type=script&setup=true&lang=js"

import "./CaskUploadInput.vue?vue&type=style&index=0&id=5a57ae0c&lang=scss"

const __exports__ = script;

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile});
